import {
  Component, ContentChild, ContentChildren, Directive, EventEmitter, forwardRef,
  Input, OnInit, Output, QueryList, TemplateRef, ViewChild, ViewChildren,
} from '@angular/core';


import {CloSplitItems} from '../button/button';
import {CheckboxControlValueAccessor, ControlValueAccessor, NG_VALUE_ACCESSOR, RadioControlValueAccessor} from '@angular/forms';


@Directive({selector: 'clo-choic-label'})
export class CloChoiceLabel {
  constructor(public templateRef: TemplateRef<any>) {}
}

@Directive({selector: 'clo-choice-option'})
export class CloChoiceOption {

  @Input() isDefault: boolean;
  @Input() label: string;
  @Input() value: any;
  @Input() id: string;

}
@Directive({
  selector: 'clo-radio-option',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CloRadioOption),  // replace name as appropriate
      multi: true
    }
  ]})
export class CloRadioOption extends RadioControlValueAccessor {
  /**
   * Boolean value to determine if input is disabled
   */
  @Input() disabled: boolean;
  @Input() isDefault: boolean;
  @Input() label: string;
  @Input() id: string;
  @Input() name: string;
  @Input() radioValue: string | number | boolean;
  values = {};
  @Input('value')
  val: string | number | boolean;

  // get value(): string | number | boolean {
  //   return this.values[this.name];
  // }

  // set value(v: string | number | boolean) {
  //   console.log('Set Value: ' + v);
  //   if (v !== this.val) {
  //     this.values[this.name] = v;
  //     this.change(v);
  //   }
  // }
  onChange: any = () => { };
  onTouched: any = () => { };
  setDisabled: any = () => { };

  change(value: string | number | boolean) {
    console.log(value);
    this.val = value;
    this.onChange(value);
    this.onTouched(value);
  }
  // We implement this method to keep a reference to the onChange
  // callback function passed by the forms API
  registerOnChange(fn) {
    this.onChange = fn;
  }
  // We implement this method to keep a reference to the onTouched
  // callback function passed by the forms API
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  // This is a basic setter that the forms API is going to use
  writeValue(value: string | number | boolean) {
    if (value !== this.val) {
      this.val = value;
    }
  }
  ngOnInit(): void {

  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

}
@Directive({
  selector: 'clo-checkbox-option',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CloCheckboxOption),  // replace name as appropriate
      multi: true
    }
  ]})
export class CloCheckboxOption extends CheckboxControlValueAccessor {
  /**
   * Boolean value to determine if input is disabled
   */
  @Input() disabled: boolean;
  @Input() isDefault: boolean;
  @Input() label: string;
  @Input() value: any;
  @Input() id: string;

  onChange = (_ => { });
  onBlur = (_ => { });
  isChecked: boolean;

  onTouched: any = () => { };
  setDisabled: any = () => { };

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  writeValue(obj: boolean): void {
    this.isChecked = obj;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onBlur = fn;
  }

  onChanged($event) {
    console.log('onChanged');
    this.isChecked = $event && $event.target && $event.target.checked;
    this.onChange(this.isChecked);
  }

}

/**
 *
 */
@Component({
  selector: 'clo-input-choice',
  templateUrl: './choice-input.html',
  styleUrls: ['./input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CloInputChoice),  // replace name as appropriate
      multi: true
    }
  ]
})
export class CloInputChoice implements OnInit {

  @ContentChildren(CloChoiceOption) options: QueryList<CloChoiceOption>;
  @ContentChildren(CloRadioOption) radioOptions: QueryList<CloRadioOption>;
  @ContentChildren(CloCheckboxOption) checkboxOptions: QueryList<CloCheckboxOption>;
  /**
   * Boolean value to determine if input is disabled
   */
  @Input() disabled: boolean;

  /**
   * Type of the input.
   *
   *  The following types are supported: `'radio'`, `'checkbox'`
   */
  @Input() type: 'radio' | 'checkbox';

  /**
   * The input name
   */
  @Input() name: string;

  /**
   * An error message
   */
  @Input() errorMessage: boolean;

  /**
   * Boolean to determine if input is required
   */
  @Input() required: boolean;

  @Input() inline = false;

  @Output() change = new EventEmitter();


  ngOnInit(): void {

  }

}

function addOrRemove(array, value) {
  const index = array.indexOf(value);

  if (index === -1) {
    array.push(value);
  } else {
    array.splice(index, 1);
  }
}
